.inline-tabs {
    display: flex;
}
